import { useContext } from 'react';

import { ensureDefined } from '@e-socna/utils';

import { AuthenticationContext } from '..';

export const useAuthenticationContext = () =>
  ensureDefined({
    context: useContext(AuthenticationContext),
  }).context;
